export const AudienceType = {
  INCLUDE: 1,
  EXCLUDE: 2,
};
